"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenTradeRepository = void 0;
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var typeorm_1 = require("typeorm");
var OpenTrade_entity_1 = require("../entities/Common/OpenTrade.entity");
var OpenTradeRepository = /** @class */ (function (_super) {
    __extends(OpenTradeRepository, _super);
    function OpenTradeRepository() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OpenTradeRepository.prototype.findByRound = function (roundID) {
        return this.find({
            relations: ['offeringTeam', 'market', 'completedTrades'],
            where: [
                {
                    startRoundID: (0, typeorm_1.LessThanOrEqual)(roundID),
                    endRoundID: (0, typeorm_1.MoreThanOrEqual)(roundID)
                }
            ]
        });
    };
    OpenTradeRepository.prototype.findByRoundAndTeam = function (roundID, team) {
        return this.find({
            relations: ['offeringTeam', 'market', 'completedTrades'],
            where: [
                {
                    startRoundID: (0, typeorm_1.LessThanOrEqual)(roundID),
                    endRoundID: (0, typeorm_1.MoreThanOrEqual)(roundID),
                    offeringTeam: team
                }
            ]
        });
    };
    OpenTradeRepository.prototype.findExpiredInRound = function (roundID) {
        var date = new Date().getTime();
        var MS_OFFSET = (0, moment_timezone_1.default)().tz('Europe/London').utcOffset() * 60 * 1000;
        var EXPIRE_TIME_IN_MS = 30 * 1000;
        var myStartDate = new Date(date - EXPIRE_TIME_IN_MS + MS_OFFSET);
        return this.find({
            where: [
                {
                    offeringTeam: 1,
                    createdAt: (0, typeorm_1.LessThan)(myStartDate),
                    volumeRemaining: (0, typeorm_1.MoreThan)(0),
                    startRoundID: roundID
                }
            ]
        });
    };
    OpenTradeRepository = __decorate([
        (0, typeorm_1.EntityRepository)(OpenTrade_entity_1.OpenTrade)
    ], OpenTradeRepository);
    return OpenTradeRepository;
}(typeorm_1.Repository));
exports.OpenTradeRepository = OpenTradeRepository;
//# sourceMappingURL=OpenTrade.js.map